var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('ChannelsHero'),_c('ChannelsSMS'),_c('ChannelsMMS'),_c('ChannelsVoice'),_c('ChannelsEmail'),_c('ChannelsChat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }